import React from "react";
import DownloadUserLog from "../DownloadReport/userLog";

export default function ScoreCardUserLog() {
  return <DownloadUserLog apiPath="backoffice/scorecard" documentLabel="Score Card" />;
}
